// src/pages/GmailSettingsPage.js
import React from 'react';
import { useSelector } from 'react-redux';
import ConnectGmailButton from '../components/leadsComponents/ConnectGmailButton';

export default function GmailSettingsPage() {
  // grab the logged-in admin (host) from Redux
  const { adminInfo } = useSelector(state => state.login);
  const isConnected = Boolean(adminInfo?.refreshToken);

  return (
    <div className="min-h-screen bg-[#F9FAFB] p-6">
      <h1 className="text-2xl font-bold text-[#1F2937] mb-6">Settings</h1>

      <section className="bg-white p-6 rounded-[16px] shadow-[0_1px_4px_rgba(0,0,0,0.05)] mb-6">
        <h2 className="text-lg font-semibold text-[#1F2937] mb-2">
          Gmail Integration
        </h2>

        {isConnected ? (
          <p className="text-sm text-[#10B981]">✅ Gmail is connected</p>
        ) : (
          <>
            <p className="text-sm text-[#6B7280] mb-4">
              Connect your Gmail account so you can send outreach emails directly.
            </p>
            <ConnectGmailButton />
          </>
        )}
      </section>

      {/* other settings sections can go here */}
    </div>
  );
}
